import { createContext, useContext } from 'react';

/**
 * Tab Context for managing tab selection state
 */
export interface TabContextValue {
  selectedIndex: number;
  setSelectedIndex: (index: number) => void;
}

export const TabContext = createContext<TabContextValue | null>(null);

export const useTabContext = (): TabContextValue | null =>
  useContext(TabContext);
